global.$ = $;
global.jQuery = $;

// vendor
import 'bootstrap';
// require('bootstrap/js/dist/modal');
// require('slick-carousel')

require('jquery-ui/dist/jquery-ui');
require('./js/vendor/jquery.ui.touch-punch');

window.tippy = require('tippy.js').default;

// custom
require('./js/components/js-image-copyright');
require('./js/components/js-touch-carousel');
require('./js/components/js-image-slider');
require('./js/components/js-custom-slider');
require('./js/components/js-image-hotspot');
require('./js/components/js-videohelper');
require('./js/components/js-effects');
require('./js/components/js-image-fixer');

import('./js/copyright');

$('.js-touch-carousel').each(function() {
    $(this).touchCarousel();
});

$('.js-slider').each(function() {
    $(this).imageSlider();
});

$('.js-custom-slider').each(function() {
    $(this).customSlider();
});

$('body').imageHotspot();
$('body').imageFixer();

$('.ce_player video').each(function() {
    $(this).videoHelper();
});

$('body').effects();

$('.js-project-data').hide();

$('.js-open-data').on('click', function (e) {
    e.preventDefault();

    $('.js-projectheader').addClass('projectheader-opening');

    setTimeout(function() {
        // $('.js-project-data').slideToggle(function () {
        console.log('complete');
        $('.js-projectheader').removeClass('projectheader-opening');
        // });
    }, 1500)

    if ($('.js-project-data').hasClass('open')) {
        // close layer
        // $('.js-projectheader').removeClass('projectheader-open');
        $('.js-project-data').removeClass('open');

        setTimeout(function() {
            $('.js-project-data').hide();
        }, 2000)

        setTimeout(function() {
            $('.js-projectheader').removeClass('projectheader-open');

        }, 1200)

    } else {
        // open layer
        // $('.js-projectheader').addClass('projectheader-open');
        $('.js-project-data').show().addClass('open');

        setTimeout(function() {
            $('.js-projectheader').addClass('projectheader-open');
        }, 1200)
    }

});

function playPauseVideo() {
    let videos = document.querySelectorAll("video");

    videos.forEach((video) => {
        if (video.autoplay == false) {
            return;
        }
        // We can only control playback without interaction if video is mute
        video.muted = true;
        // Play is a promise, so we need to check we have it
        let playPromise = video.play();
        if (playPromise !== undefined) {
            playPromise.then((_) => {
                let observer = new IntersectionObserver(
                    (entries) => {
                        entries.forEach((entry) => {
                            if (
                                entry.intersectionRatio !== 1 &&
                                !video.paused
                            ) {
                                video.pause();
                            } else if (video.paused) {
                                video.play();
                            }
                        });
                    },
                    { root: document.body, threshold: 0.2 }
                );
                observer.observe(video);
            });
        }
    });
}


$(document).ready(function() {
    $('body').addClass('loaded');
    playPauseVideo();
});

